export class TabDetailParameterName {
  static orderNumber = 'orderNumber';
  static workOrderExternalId = 'workOrderExternalId';
  static workOrderId = 'workOrderId';
  static activityId = 'activityId';
  static chartParameters = 'chartParameters';
  static hierarchyElementId = 'hierarchyElementId';
  static hierarchyElementIdsTree = 'hierarchyElementIdsTree';
  static hierarchyFamilyId = 'hierarchyFamilyId';
  static hierarchyFamilyIdTree = 'hierarchyFamilyIdTree';
  static hierarchyElementTypeFilterSetting = 'hierarchyElementTypeFilterSetting';
  // hierarchyElementTypeFilter = 'hierarchyElementTypeFilter';
  static networkElementTypeFilterSetting = 'networkElementTypeFilterSetting';
  // networkElementTypeFilter = 'networkElementTypeFilter';
  static startDate = 'startDate';
  static endDate = 'endDate';
  static mapParameters = 'mapParameters';
  static dataBindingFilter = 'dataBindingFilter';
  static textField = 'textField';
  static elementId = 'elementId';
  static hasPersistencySave = 'hasPersistencySave';
  static openActivities = 'openActivities';
  static activities = 'activities';
  static elementName = 'elementName';
  static filterExpanded = 'filterExpanded';
  static signalId = 'signalId';
  static pointId = 'pointId';
  static scenarioId = 'scenarioId';
  static modelId = 'modelId';
  static modelVersionId = 'modelVersionId';
  static Group = 'Group';
  static user = 'user';
  static waterBalanceType = 'waterBalanceType';
  static waterBalanceChart = 'waterBalanceChart';
  static dimensionType = 'dimensionType';
  static basicFilters = 'basicFilters';
  static timeSelectorChartSetting = 'timeSelectorChartSetting';
  static alarmTypeId = 'alarmTypeId';
  static profileConfiguration = 'profileConfiguration';
  static algorithm = 'algorithm';
  static notification = 'notification';
  static notificationId = 'notificationId';
  static isZone = 'isZone';
  static customer = 'customer';
  static networkElementId = 'networkElementId';
  static dynamicFormSource = 'dynamicFormSource';
  static dynamicFormLayoutKeys = 'dynamicFormLayoutKeys';
  static networkElement = 'networkElement';
  static configuredStateService = 'configuredStateService';
  static selectedFormCategories = 'selectedFormCategories';
  static campaign = 'campaign';
  static systemLog = 'systemLog';
  static audit = 'auditId';
  static pageId = 'pageId';

  // Generic, RP-related settings
  static subtitle = 'subtitle';
  static titleSidePills = 'titleSidePills';
  static stylizedTitleSidePills = 'stylizedTitleSidePills';
  static topAttributes = 'topAttributes';
  static topValues = 'topValues';
  static containerClass = 'containerClass';
  static refreshAlarmChart = 'refreshAlarmChart';
  static buttonWithDetails = 'buttonWithDetails';
}

export class TabDetailPanelParameters {
  parameters: Map<TabDetailParameterName, any>;
  constructor() {
    this.parameters = new Map<TabDetailParameterName, any>();
  }
  public addParameter(key: TabDetailParameterName, value: any, update = true) {
    if (this.parameters.has(key)) {
      if (update) {
        this.parameters.set(key, value);
      } else {
        throw new Error(`Parameter already exists ${key}`);
      }
    } else {
      this.parameters.set(key, value);
    }
  }
}
